var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlainArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "11px",
    viewBox: "0 0 19 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrows / down@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---FAQ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FAQ---Default",
    transform: "translate(-1131.000000, -277.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(269.000000, 257.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrows-/-up",
    transform: "translate(861.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4140625,13.1300223 C19.5355909,13.2527908 19.5963542,13.3939724 19.5963542,13.5535714 C19.5963542,13.7131704 19.5355909,13.8543521 19.4140625,13.9771205 L10.9192708,22.5585938 C10.7977424,22.6813622 10.6579869,22.7427455 10.5,22.7427455 C10.3420131,22.7427455 10.2022576,22.6813622 10.0807292,22.5585938 L1.5859375,13.9771205 C1.46440911,13.8543521 1.40364583,13.7131704 1.40364583,13.5535714 C1.40364583,13.3939724 1.46440911,13.2527908 1.5859375,13.1300223 L2.49739583,12.2092634 C2.61892422,12.0864949 2.75867977,12.0251116 2.91666667,12.0251116 C3.07465357,12.0251116 3.21440911,12.0864949 3.3359375,12.2092634 L10.5,19.4464286 L17.6640625,12.2092634 C17.7855909,12.0864949 17.9253464,12.0251116 18.0833333,12.0251116 C18.2413202,12.0251116 18.3810758,12.0864949 18.5026042,12.2092634 L19.4140625,13.1300223 Z",
    id: "\\uF107",
    transform: "translate(10.500000, 17.383929) scale(-1, -1) translate(-10.500000, -17.383929) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlainArrowUp);
export default __webpack_public_path__ + "static/media/PlainArrowUp.51986fb4dce6a2f092c75275f5449e78.svg";
export { ForwardRef as ReactComponent };